import { CRStatus } from '@scaleup/models';
import { toTitleCase } from '../../utils';

export const CapitalRequestDealTracker = ({ status }: { status: string }) => {
  return (
    <div className="inline-flex	 rounded-[1rem] h-[40px] gap-[1px]">
      <div className="has-tooltip relative">
        <div
          className={`flex justify-center items-center flex-col shadow-warning rounded-s-[16px] bg-warning-75 h-[40px] ${status === CRStatus.GENERATING_MATCHES ? 'w-[168px]' : 'w-[83px] opacity-25'}`}
        >
          <span className="text-text-disabled font-black text-[10px]">1</span>
          {status === CRStatus.GENERATING_MATCHES && (
            <p className="text-white text-sm font-medium text-[10px]">
              Generating Matches
            </p>
          )}
        </div>
        {status !== CRStatus.GENERATING_MATCHES && (
          <span className="tooltip text-center after:content-[''] after:absolute after:w-0 after:left-1/2 after:h-0 after:border-l-8 after:border-l-transparent after:border-r-8 after:border-r-transparent after:border-t-[16px] after:-bottom-3 after:border-gray-900">
            Generating Matches
          </span>
        )}
      </div>
      <div className="has-tooltip relative">
        <div
          className={`flex justify-center items-center flex-col shadow-warning bg-blue-500 h-[40px] ${status === CRStatus.PROVIDERS_PRESENTED ? 'w-[168px]' : 'w-[83px] opacity-25'}`}
        >
          <span className="text-tertiary-700 font-black text-[12px]">2</span>
          {status === CRStatus.PROVIDERS_PRESENTED && (
            <p className="text-white text-sm font-medium text-[10px]">
              Providers Presented
            </p>
          )}
        </div>
        {status !== CRStatus.PROVIDERS_PRESENTED && (
          <span className="tooltip text-center after:content-[''] after:absolute after:w-0 after:left-1/2 after:h-0 after:border-l-8 after:border-l-transparent after:border-r-8 after:border-r-transparent after:border-t-[16px] after:-bottom-3 after:border-gray-900">
            Providers Presented
          </span>
        )}
      </div>
      <div className="has-tooltip relative">
        <div
          className={`flex justify-center items-center flex-col shadow-warning bg-primary-500 h-[40px] ${status === CRStatus.INTRODUCTIONS ? 'w-[168px]' : 'w-[83px] opacity-25'}`}
        >
          <span className="text-primary-700 text-xs">3</span>
          {status === CRStatus.INTRODUCTIONS && (
            <p className="text-white text-sm font-medium text-[10px]">
              Introductions
            </p>
          )}
        </div>
        {status !== CRStatus.INTRODUCTIONS && (
          <span className="tooltip text-center after:content-[''] after:absolute after:w-0 after:left-1/2 after:h-0 after:border-l-8 after:border-l-transparent after:border-r-8 after:border-r-transparent after:border-t-[16px] after:-bottom-3 after:border-gray-900">
            Introductions
          </span>
        )}
      </div>
      <div className="has-tooltip relative">
        <div
          className={`flex justify-center items-center flex-col shadow-warning bg-green-500 h-[40px] ${status === CRStatus.NEGOTIATIONS ? 'w-[168px]' : 'w-[83px] opacity-25'}`}
        >
          <span className="text-green-700 text-xs">4</span>
          {status === CRStatus.NEGOTIATIONS && (
            <p className="text-white text-sm font-medium text-[10px]">
              Negotiations
            </p>
          )}
        </div>
        {status !== CRStatus.NEGOTIATIONS && (
          <span className="tooltip text-center after:content-[''] after:absolute after:w-0 after:left-1/2 after:h-0 after:border-l-8 after:border-l-transparent after:border-r-8 after:border-r-transparent after:border-t-[16px] after:-bottom-3 after:border-gray-900">
            Negotiations
          </span>
        )}
      </div>
      <div className="has-tooltip relative">
        <div
          className={`flex justify-center items-center flex-col shadow-warning rounded-e-[16px] bg-secondary-500 h-[40px] ${
            status === CRStatus.DEAL_WON || status == CRStatus.DEAL_LOST
              ? 'w-[168px]'
              : 'w-[83px] opacity-25'
          }`}
        >
          <span className="text-secondary-700 text-xs">5</span>
          {(status === CRStatus.DEAL_WON || status === CRStatus.DEAL_LOST) && (
            <p className="text-white text-sm font-medium text-[10px]">
              {toTitleCase(status.split('_').join(' '))}
            </p>
          )}
        </div>
        {status !== CRStatus.DEAL_WON && status !== CRStatus.DEAL_LOST && (
          <span className="tooltip text-center after:content-[''] after:absolute after:w-0 after:left-1/2 after:h-0 after:border-l-8 after:border-l-transparent after:border-r-8 after:border-r-transparent after:border-t-[16px] after:-bottom-3 after:border-gray-900">
            Deal Status
          </span>
        )}
      </div>
    </div>
  );
};
